import React from 'react';
import Grid from '@material-ui/core/Grid';
import styled from 'styled-components/macro';
import Colors from '../../internal-components/Colors';
import useTranslations from '../../hooks/useTranslations';
import Loader from '../Loader';
import EmptyState from '../engine/EmptyPageStateEngine';

import DashboardCard from '../engine/DashboardCardEngine';
import useGlobalVariables from '../../hooks/useGlobalVariables';
import TabsEngine from '../engine/TabsEngine';
import Tab from '@material-ui/core/Tab';
import EndUserTaskTableEngine from '../tasks/engine/EndUserTaskTableEngine';

const Welcome = styled.div`
  padding: 1.5em 1.5em;
  color: ${Colors.DARK_GREY};
  background: #fff;
  margin: 1.8em 0;
  border-radius: 4px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
`;

const WelcomeTitle = styled.h2`
  color: #000;
  font-size: 24px;
  font-weight: 500;
  margin: 0;
  margin-bottom: 0.3em;
`;

const GridOfForms = styled(Grid)`
  margin-top: 5px;
`;

const EndUserDashboardView = props => {
  const t = useTranslations();
  const { isMobileView } = useGlobalVariables();

  return (
    <>
      <Loader isLoading={props.isInitialLoading} />
      {props.isInitialLoading ? null : (
        <>
          {isMobileView ? null : (
            <Welcome>
              <WelcomeTitle>
                {t('landingPage.welcome', {
                  firstName: props.userProfile
                    ? props.userProfile.firstName
                    : 'user'
                })}
              </WelcomeTitle>
              {props.reducerState.formsData.length === 0
                ? null
                : t('landingPage.welcome.subtext')}
            </Welcome>
          )}

          {props.tasksCount ? (
            <TabsEngine
              key="end-user-tabs"
              value={props.endUserTab}
              onChange={props.changeEndUserTab}
            >
              <Tab
                key="tab0"
                value="tasks"
                label={`My Tasks (${props.tasksCount || '0'})`}
                data-testid="tasks-tab"
              />
              <Tab
                key="tab1"
                value="forms"
                label={`My Forms (${
                  props.reducerState?.formsData?.length || '0'
                })`}
                data-testid="forms-tab"
              />
            </TabsEngine>
          ) : (
            ''
          )}
          {props.endUserTab === 'tasks' ? (
            <div>
              <EndUserTaskTableEngine />
            </div>
          ) : (
            ''
          )}
          {props.endUserTab === 'forms' ? (
            props.reducerState.formsData.length === 0 ? (
              <EmptyState
                title="landingPage.empty.forms.title"
                description="landingPage.empty.forms"
                imageSrc="emptystate.svg"
                wrapperCSS="max-width: none; border-radius: 4px; border-bottom: 1px solid rgba(0,0,0,0.12);"
              />
            ) : (
              <GridOfForms spacing={2} container>
                {props.reducerState.formsData.map(formNode => {
                  return (
                    <Grid
                      key={formNode.id}
                      item
                      xl={3}
                      lg={3}
                      md={6}
                      sm={12}
                      xs={12}
                    >
                      <DashboardCard formNode={formNode} />
                    </Grid>
                  );
                })}
              </GridOfForms>
            )
          ) : (
            ''
          )}
        </>
      )}
    </>
  );
};

export default EndUserDashboardView;
